import { showAsDropDownTitle } from 'owa-locstrings/lib/strings/showasdropdowntitle.locstring.json';
import { private_0 } from './getShowAsMenuItems.locstring.json';
import loc from 'owa-localize';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { generateShowAsItems } from './generateShowAsItems';

import { ControlIcons } from 'owa-control-icons';
import { FreeBusyType } from 'owa-freebusy-style';
import { IContextualMenuItem, ContextualMenuItemType } from '@fluentui/react/lib/ContextualMenu';
import { isOnGroupCalendar } from 'owa-calendar-event-capabilities';

/**
 * Generates sub-menu options for Show As menu.  Current item's freebusyType is checked.
 */

export const getShowAsMenuItems = (
    item: CalendarEvent,
    onClickShowAs: (freeBusy: FreeBusyType) => void,
    colorScheme: ColorScheme,
    onSensitivityToggled: () => void,
    showPrivateOption?: boolean
): IContextualMenuItem[] => {
    const isPrivate = item.Sensitivity == 'Private';

    // https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/43633
    // It makes no sense to mark events in group calendars as private; disable the UI for this.
    const isGroupEvent = isOnGroupCalendar(item);

    const privateOption: IContextualMenuItem[] =
        showPrivateOption && !isGroupEvent
            ? [
                  {
                      key: 'visibility_divider',
                      itemType: ContextualMenuItemType.Divider,
                  } as IContextualMenuItem,
                  {
                      key: 'sensitivity',
                      name: loc(private_0),
                      iconProps: {
                          iconName: isPrivate ? ControlIcons.Lock : ControlIcons.Unlock,
                      },
                      onClick: onSensitivityToggled,
                      canCheck: true,
                      isChecked: isPrivate,
                  },
              ]
            : [];
    return [
        {
            key: 'showAs_title',
            itemType: ContextualMenuItemType.Header,
            name: loc(showAsDropDownTitle),
            iconProps: {
                style: {
                    display: 'none',
                },
            },
        } as IContextualMenuItem,
        ...generateShowAsItems(item, onClickShowAs, colorScheme),
        ...privateOption,
    ];
};
